<xux-widget-boilerplate [field]="field">
  <div class="multi-selection-list">
    <ul>
      <li
        *ngFor="let row of dataObs | async"
        class="selection-row"
        [class]="row.groupClass"
        triggers="mouseenter:mouseleave"
        [tooltip]="getTooltip(row)"
        [isDisabled]="!getTooltip(row) || !showTooltip"
        [container]="'body'"
        placement="{{ placement }}"
      >
        <div
          *ngFor="let rowItem of row.items"
          class="item"
          [class]="rowItem.itemClass"
        >
          {{ rowItem.item }}
        </div>
      </li>
    </ul>
  </div>
</xux-widget-boilerplate>
